import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminHeader from '../../components/ui/AdminHeader';
import Icon from '../../components/AppIcon';

const SessionListDashboard = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <AdminHeader />
      <main className="pt-16">
        <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-12">
          <div className="mb-6 md:mb-8">
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-2">도구</h1>
            <p className="text-base md:text-lg caption text-muted-foreground">원하는 작업을 선택하세요</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            <button
              className="bg-card border border-border rounded-xl hover-lift transition-athletic p-5 md:p-6 flex flex-col items-start text-left"
              onClick={() => navigate('/session-list-dashboard/invite')}
              type="button"
            >
              <div className="w-14 h-14 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <Icon name="Send" size={34} color="var(--color-primary)" />
              </div>

              <div className="mt-4">
                <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">이벤트 만들기</h2>
                <p className="text-sm caption text-muted-foreground mt-2 leading-relaxed">다양한 매치를 자유롭게 만들어서 카카오톡 및 각종 게시판과 URL로 공유해보세요</p>
              </div>
            </button>

            <button
              className="bg-card border border-border rounded-xl hover-lift transition-athletic p-5 md:p-6 flex flex-col items-start text-left"
              onClick={() => navigate('/session-list-dashboard/bracket')}
              type="button"
            >
              <div className="w-14 h-14 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <Icon name="Swords" size={34} color="var(--color-accent)" />
              </div>

              <div className="mt-4">
                <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">대진표 작성</h2>
                <p className="text-sm caption text-muted-foreground mt-2 leading-relaxed">다양한 룰 형식에 맞게 대진표를 작성하고 URL로 공유하세요</p>
              </div>
            </button>

            <button
              className="bg-card border border-border rounded-xl hover-lift transition-athletic p-5 md:p-6 flex flex-col items-start text-left"
              onClick={() => navigate('/member-management')}
              type="button"
            >
              <div className="w-14 h-14 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <Icon name="Users" size={34} color="var(--color-primary)" />
              </div>

              <div className="mt-4">
                <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">맴버</h2>
                <p className="text-sm caption text-muted-foreground mt-2 leading-relaxed">당신만의 회원을 등록해 데이터베이스를 구축하세요</p>
              </div>
            </button>

            <button
              className="bg-card border border-border rounded-xl hover-lift transition-athletic p-5 md:p-6 flex flex-col items-start text-left"
              onClick={() => navigate('/openplay/notifications')}
              type="button"
            >
              <div className="w-14 h-14 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <Icon name="Bell" size={34} color="var(--color-accent)" />
              </div>

              <div className="mt-4">
                <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">알림</h2>
                <p className="text-sm caption text-muted-foreground mt-2 leading-relaxed">카카오톡 연동 및 다양한 이벤트 시 알림을 설정해보세요</p>
              </div>
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default SessionListDashboard;